export default "<app-not-found\n    [icon]=\"icon | assetImage\"\n    [heading]=\"heading\"\n    [message]=\"message\">\n</app-not-found>"